module.exports = __webpack_public_path__ + "media/icons/link-www-91c0fc1d.png";